export default __webpack_public_path__ + "static/media/ubicacion-title-god.80b2cfca.svg";